module.exports = __webpack_public_path__ + "img/user104.04d5081e.jpg";